<app-header></app-header>

<div class="home-page">
	<main>
		<router-outlet></router-outlet>
	</main>
</div>

<app-footer></app-footer>
